function dataURLtoFile (dataurl, filename = 'file') {
  let arr = dataurl.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let suffix = mime.split('/')[1] // 获取图片的后缀，png jpg等
  let bstr = atob(arr[1]) // 对base64进行解码
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], `${filename}.${suffix}`, {
    type: mime
  })
}

function yasuo (path, file, config) {
  return new Promise((resolve, reject) => {
    var img = new Image()
    img.src = path
    const isLt2M = file.size / 1024 / 1024 < 4
    img.onload = function () {
      if (isLt2M) {
        resolve(file)
      } else {
        var that = this
        var w = that.width
        var h = that.height
        var scale = w / h
        if (w > config.width) {
          w = config.width || config.height * scale
          h = config.height || config.width / scale
        }
        var quality = 1 // 默认图片质量为1
        // 生成canvas
        var canvas = document.createElement('canvas')
        var ctx = canvas.getContext('2d')
        // 创建属性节点
        var anw = document.createAttribute('width')
        anw.nodeValue = w
        var anh = document.createAttribute('height')
        anh.nodeValue = h
        canvas.setAttributeNode(anw)
        canvas.setAttributeNode(anh)
        ctx.drawImage(that, 0, 0, w, h)
        if (config.quality && config.quality <= 1 && config.quality > 0) {
          quality = config.quality
        }
        var base64 = canvas.toDataURL('image/*', quality)
        let files = dataURLtoFile(base64)
        // var blob = convertBase64UrlToBlob(base64)
        // 回调函数返回base64的值，也可根据自己的需求返回blob的值
        resolve(files)
      }
    }
  })
}
// 压缩图片
export function compressImages (imgList, config) {
  let arr = []
  imgList.forEach(item => {
    if (item) {
      arr.push(yasuo(item.url, item.raw, config))
    } else {
      arr.push(null)
    }
  })
  return Promise.all(arr).then((result) => {
    return result
  }).catch((error) => {
    console.log(error)
  })
}

// 压缩图片函数（修改版）
export function compressImagesFn (imgList, config) {
  // 过滤掉无效图片，确保只处理有效图片
  const validImages = imgList.filter(img => img !== null && img !== undefined)

  // 为每个有效图片创建压缩Promise
  const promises = validImages.map(item => {
    // 确保图片对象包含必要属性
    if (!item || !item.url || !item.raw) {
      return Promise.resolve(null)
    }
    return yasuo(item.url, item.raw, config)
  })

  return Promise.all(promises)
    .then(results => {
      // 构建与原始imgList相同长度的结果数组，无效位置填充null
      const fullResults = new Array(imgList.length).fill(null)
      let validIndex = 0

      imgList.forEach((img, index) => {
        if (img !== null && img !== undefined) {
          fullResults[index] = results[validIndex]
          validIndex++
        }
      })

      return fullResults
    })
    .catch(error => {
      console.error('图片压缩失败:', error)
      throw error // 确保错误能被上层捕获
    })
}
